import { getWishlistProductMultipleSizes } from 'components/wishlist/utils'
import WishlistApiHandler from 'lib/api/wishlist'

export const addToWishlist = async (product_id, setIsWishlisted) => {
  try {
    setIsWishlisted(true)
    await WishlistApiHandler.addWishlist({ product_id })
  } catch (e) {
    setIsWishlisted(false)
  }
}

export const deleteFromWishlist = async (productId, setIsWishlisted) => {
  try {
    setIsWishlisted(false)
    await WishlistApiHandler.deleteWishlist({ productId })
  } catch (e) {
    setIsWishlisted(true)
  }
}

/**
 * @param {number} productId
 * @param {Object} user
 * @param {Function} setIsSnackBarOpen - Setter to open snackbar
 * @param {Function} setIsWishlisted - Setter for wishlist status
 */
export const checkWishlistProductMultipleSizes = async (
  productId,
  user,
  setIsSnackBarOpen,
  setIsWishlisted,
) => {
  const hasWishlistProductMultipleSizes = await getWishlistProductMultipleSizes(
    productId,
    user,
  )

  if (hasWishlistProductMultipleSizes) {
    setIsSnackBarOpen(true)
  } else {
    deleteFromWishlist(productId, setIsWishlisted)
  }
}
